/** Tokens visuais — despesas do evento (mesmo padrão dos recebimentos) */
export const DESPESAS_ACCENT = "#F96030";
export const DESPESAS_INK = "#1a2035";
export const DESPESAS_ACCENT_SOFT = "rgba(249, 96, 48, 0.08)";

export const despesasToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${DESPESAS_ACCENT}`,
};

export const despesasSectionSx = {
  p: { xs: 1.5, sm: 2 },
  borderRadius: 2,
  border: "1px solid",
  borderColor: "grey.200",
  bgcolor: "background.paper",
};
